import {h, Fragment} from "preact"
import Icon from "./Icon"

export default function SubmitButton({ className, text }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ns-p-3 pd-autocomplete-submit ${className}`}>
            <button type="submit" className="ns-act-btn pd-text-uppercase ns-font-5 ns-text-align-right ns-w-100 pd-autocomplete-more-results ns-font-thin ns-color-black-alt">
                {text}
                <Icon name="arrow-right" className="ns-ml-2" />
            </button>
        </div>
    )
}